export const FALLBACK_INITIAL_POSITION = {
  longitude: -98.647,
  latitude: 31.904,
  zoom: 6,
};

export const strToGeo = geoUrlStr => {
  if (!geoUrlStr) return null;

  return {
    longitude: Number.parseFloat(geoUrlStr.split(';')[0].split(',')[1]),
    latitude: Number.parseFloat(geoUrlStr.split(';')[0].split(',')[0]),
    zoom: Number.parseFloat(geoUrlStr.split(';')[1]),
  };
};

export const geoToStr = (longitude, latitude, zoom) => {
  if (longitude && latitude && zoom) return `${latitude},${longitude};${zoom}`;
  if (longitude && latitude) return `${latitude},${longitude}`;
};

export const formattedGeoToStr = (longitude, latitude, zoom) => {
  return geoToStr(
    Number.parseFloat(longitude).toFixed(4),
    Number.parseFloat(latitude).toFixed(4),
    Number.parseFloat(zoom) ? Number.parseFloat(zoom).toFixed(1) : undefined,
  );
};
